import React from 'react';

const IconLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g id="Logo" transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <path
         d="M38.2,37.3h7.5v36.5h-7.5V37.3z M37.4,25c-0.2,0.5-0.3,1.1-0.3,1.7c0,0.1,0,0.2,0,0.3c0,1.1,0.5,2.1,1.3,2.8
	c0.6,0.5,1.3,0.9,2,1c0.5,0.1,1,0.2,1.5,0.2c0.5,0,0.9,0,1.3-0.1c0.8-0.2,1.6-0.5,2.2-1.1c0.5-0.4,0.9-1,1.1-1.6
	c0.2-0.5,0.3-1,0.3-1.5c0-0.1,0-0.1,0-0.2c0-1.1-0.5-2.2-1.4-3c-0.9-0.8-2.1-1.3-3.5-1.3c-0.4,0-0.8,0-1.2,0.1
	c-0.9,0.2-1.7,0.5-2.3,1.1C38,23.9,37.7,24.4,37.4,25z"
          fill="#64FFDA"
        />
        <polygon
          id="Shape"
          stroke="#64FFDA"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
         points="42,3 3,25 3,70 42,93 81,71 81,26"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;